import styled, {keyframes} from "styled-components";

const pulse = keyframes`
	50% { opacity: 0.45; }
`;

/**
 * v3 loading ghost (the analytics skeleton-tile idiom): a pulsing block on the token field
 * surface. Shared by the contacts-list and groups-grid skeletons so both tabs load in the same
 * visual language; the pulse respects `prefers-reduced-motion`.
 */
export const Ghost = styled.span<{$w: string; $h: string; $r?: string}>`
	display: block;
	width: ${({$w}) => $w};
	height: ${({$h}) => $h};
	border-radius: ${({$r}) => $r ?? "6px"};
	background: ${({theme}) => theme.tokens.field};

	@media (prefers-reduced-motion: no-preference) {
		animation: ${pulse} 1.5s ease-in-out infinite;
	}
`;
